import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const StarWithBorderIcon = ({
  width = "24",
  height = "24",
  color = "#4C545B",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 15.89L8.24 18.16L9.23 13.88L5.91 11L10.29 10.63L12 6.59L13.71 10.63L18.09 11L14.77 13.88L15.76 18.16M22 9.74L14.81 9.13L12 2.5L9.19 9.13L2 9.74L7.45 14.47L5.82 21.5L12 17.77L18.18 21.5L16.54 14.47L22 9.74Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
